import React from 'react';
import { Grid, MessageSquare } from 'lucide-react';

const ModeToggle = ({ mode, onModeChange, disabled = false }) => {
  return (
    <div className="flex items-center space-x-1 bg-slate-100 dark:bg-slate-800 p-1 rounded-lg">
      <button
        className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center ${
          mode === 'traditional' 
            ? 'bg-white dark:bg-slate-700 text-slate-900 dark:text-white shadow-sm' 
            : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'
        }`}
        onClick={() => onModeChange('traditional')}
        disabled={disabled}
      >
        <Grid size={16} className="mr-2" />
        Traditional
      </button>
      <button
        className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center ${
          mode === 'chat' 
            ? 'bg-white dark:bg-slate-700 text-slate-900 dark:text-white shadow-sm' 
            : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'
        }`}
        onClick={() => onModeChange('chat')}
        disabled={disabled}
      >
        <MessageSquare size={16} className="mr-2" />
        Chat
      </button>
    </div>
  );
};

export default ModeToggle;